import { OrganizationSOW } from './organizationSOWs.models';

export interface SOWState {
  ids: string[];
  entities: Record<string, OrganizationSOW>;
  currentSOWId: string | null;
  isLoaded: boolean;
  isLoading: boolean;
  error: string | null;
}

type Action =
  | {
      type: 'SET_LOADING_STATE';
      payload: Pick<SOWState, 'isLoading' | 'isLoaded'>;
    }
  | { type: 'FETCH_SOWS' }
  | {
      type: 'FETCH_SOWS_SUCCESS';
      payload: { sows: OrganizationSOW[] };
    }
  | { type: 'FETCH_SOWS_FAILURE'; payload: { error: string } };

export const initState: SOWState = {
  ids: [],
  entities: {},
  currentSOWId: null,
  isLoaded: false,
  isLoading: false,
  error: null,
};

export const SOWReducer = (state: SOWState, action: Action): SOWState => {
  switch (action.type) {
    case 'SET_LOADING_STATE':
      return {
        ...state,
        ...action.payload,
        error: null,
      };

    case 'FETCH_SOWS':
      return {
        ...state,
        isLoading: true,
        isLoaded: !!state.ids.length,
        error: null,
      };
    case 'FETCH_SOWS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ids: [...new Set(action.payload.sows.map((s) => s.sowId))],
        entities: action.payload.sows.reduce(
          (prev, curr) => ({ ...prev, [curr.sowId]: curr }),
          {}
        ),
      };
    case 'FETCH_SOWS_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
